import { render, staticRenderFns } from "./prize-statistics.vue?vue&type=template&id=67fca07e&scoped=true&"
import script from "./prize-statistics.vue?vue&type=script&lang=js&"
export * from "./prize-statistics.vue?vue&type=script&lang=js&"
import style0 from "./prize-statistics.vue?vue&type=style&index=0&id=67fca07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fca07e",
  null
  
)

export default component.exports